<template lang="pug">
section
  v-card(:flat='flat')
    v-toolbar(flat color='white')
      h2(class='title font-weight-medium') Менеджеры
      v-spacer
    v-toolbar(flat color='white')
      v-layout(wrap)
        v-flex(xs8 sm8)
          v-select(
            v-if='attributes'
            :items='managersList'
            item-text='full_name'
            item-value='id'
            v-model='manager'
            label='Выберите менеджера'
          )
        v-flex(xs2 sm2)
          v-btn(color='primary' 
              @click.stop='onAdd()'
              :style='{ margin: 0 }'
            ) Добавить
        v-flex(xs2 sm2)
          s-sort-button(@click='sorting.opened = true' class='mr-3')
    v-data-table(
      :loading='isLoading'
      :headers='headers'
      :items='list'
      :hide-actions='true'
    )
      template(slot='items' slot-scope='props')
        tr(class='with-pointer')
          td(data-label='#ID') {{ props.item.id }}
          td(data-label='Имя') {{ props.item.manager.full_name }}
          td(data-label='Должность') {{ props.item.manager.position }}
          td(class='text-xs-right wrapless crud-tools')
            v-btn(icon @click.stop='onDelete(props.item.id)')
              v-icon(small) delete_outline
  s-sorting-list(
    v-model='sorting'
    :collection='list'
    @sort-success='updateItem'
    @sort-request='sortManagers'
  )
</template>

<script>

import http from '@/http'
import { differenceBy } from 'lodash'

export default {
  data: () => ({
    headers: [
      { text: '#ID', align: 'left', value: 'id', width: '0%', sortable: false },
      {
        text: 'Имя',
        align: 'left',
        value: 'full_name',
        width: '30%',
        sortable: false
      },
      {
        text: 'Должность',
        align: 'left',
        value: 'position',
        width: '50%',
        sortable: false
      },
      { text: '', align: 'left', width: '0%', sortable: false }
    ],
    manager: null,
    selectedOffice: {},
    sorting: {
      opened: false,
      itemValue: 'id',
      itemText: 'name',
      renderFn(item) {
        return item.manager.full_name
      }
    }
  }),

  props: ['isLoading', 'list', 'flat', 'attributes', 'cityId'],

  methods: {
    updateItem() {
      this.$emit('update')
    },
    async sortManagers(ids) {
      try {
        await http.post(`/development/cities/${this.cityId}/managers/sort`, { sort_ids: ids })
        this.updateItem()
      } catch(error) {
        this.$root.showSnack('Ошибка сортировки')
      }
    },
    onDelete(id) {
      this.$emit('delete', id)
    },

    onAdd() {
      this.$emit('add', this.manager)
      this.manager=null
    }
  },
  computed: {
    managersList() {
      if (!this.attributes.managers) return []
      return differenceBy(this.attributes.managers, this.list, 'id')
    }
  }
}
</script>

<style scoped>
.toolbar {
  z-index: 10;
}
</style>
